import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

export const InputRadio = (props) => {
    return (
        <FormControl component="fieldset">
            <FormLabel component="legend"></FormLabel>
            <RadioGroup aria-label={props.arial_label} name={props.name} value={props.value} onChange={props.onChange}>
                {props.arrayRadioItems.map((elem, index) => (
                     <FormControlLabel key={index} className='radio-label' value={elem.labalValue} control={<Radio />} label={elem.labelTitel} />
                ))}
            </RadioGroup>
        </FormControl>
    )
}